import { useMemo, useState, type FormEvent } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { BrandLogo } from '../../shared/BrandLogo'
import { adminApi } from '../api'
import { safeAdminError } from '../safe-ui'

export function AdminResetPasswordPage() {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const token = useMemo(() => (params.get('token') || '').trim(), [params])
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState('')
  const [info, setInfo] = useState('')
  const [busy, setBusy] = useState(false)

  async function onSubmit(e: FormEvent) {
    e.preventDefault()
    setBusy(true)
    setError('')
    setInfo('')
    try {
      if (!token) throw new Error('Reset link is missing or invalid')
      if (password.length < 8) throw new Error('Password must be at least 8 characters')
      if (password !== confirm) throw new Error('Password confirmation does not match')
      const res = await adminApi.resetPassword(token, password)
      setInfo(res.message || 'Password updated')
      window.setTimeout(() => navigate('/admin/login', { replace: true }), 1200)
    } catch (err) {
      setError(safeAdminError(err, 'Unable to reset password'))
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="ap-auth">
      <form className="ap-auth__card" onSubmit={(e) => void onSubmit(e)}>
        <BrandLogo className="ap-auth__logo" tone="light" variant="mark" />
        <p className="cp-eyebrow">Master Admin</p>
        <h1>Reset password</h1>
        <p className="cp-muted">Choose a new password for your admin account.</p>
        {error ? <p className="cp-error">{error}</p> : null}
        {info ? <p className="cp-success">{info}</p> : null}
        <label className="cp-field">
          New password
          <input
            type="password"
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            minLength={8}
            required
          />
        </label>
        <label className="cp-field">
          Confirm password
          <input
            type="password"
            autoComplete="new-password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            minLength={8}
            required
          />
        </label>
        <button type="submit" className="pp-btn pp-btn--primary" disabled={busy || !token}>
          {busy ? 'Updating…' : 'Update password'}
        </button>
        <p className="cp-muted" style={{ marginTop: '0.85rem' }}>
          <Link to="/admin/login">Back to sign in</Link>
        </p>
      </form>
    </div>
  )
}
